import DefaultPhoneStep from './defaultPhoneStep.view';

export default DefaultPhoneStep;
